import React from 'react';
import Layout from '~/components/Layout';
import { graphql } from 'gatsby';
import useStoryblok from '~/utils/storyblok-service';
import StoryPreview from '~/components/StoryPreview';
import TestimonialAlt from '~/components/TestimonialAlt';
import Image from '~/components/Dynamic/Image';
import FeaturedCustomerSection from '~/components/Dynamic/FeaturedCustomerSection';
import Seo from '~/components/SEO';
import useCustomerPreviews from '~/hooks/useCustomerPreviews';

const CustomersListing = ({ data, location, pageContext }) => {
  const story = useStoryblok(data.storyblokEntry, location);
 

  const content = story?.content;
  const hero = content?.hero[0];
  const customerPreviews = useCustomerPreviews().filter(p => p.lang === pageContext.lang)

  return (
    <Layout headerColor="black" locale={pageContext.locale}>
      <Seo {...content.seo} lang={story.lang} pageContext={pageContext} />

      <section className="pt-10 mb-24 -mt-20 text-white bg-black">
        <div className="container flex flex-col justify-center py-24 md:py-40 pt-42">
          <div className="flex flex-col items-center justify-center">
            <h1 className="max-w-lg text-center text-white text-h1">{hero.textCard[0].heading}</h1>
            <div className="mt-3 text-center text-white text-20px md:text-24px ">
              <p>{hero.textCard[0].content}</p>
            </div>
          </div>
          <div className="flex-auto mt-12 md:mt-24">
            <Image blok={hero.asset[0]} loading="eager" imageClassName="w-full" />
          </div>
        </div>
      </section>

      {content?.featured?.length > 0 && <FeaturedCustomerSection blok={content.featured[0]} />}
      {content?.testimonial?.length > 0 && <TestimonialAlt blok={content.testimonial[0]} />}

      <section className="my-20 md:my-32">
        <div className="container">
          <div className="grid gap-10 md:gap-16 md:grid-cols-2">
            {customerPreviews.map((post) => (
              <div key={post.uuid} className="flex flex-col">
                <StoryPreview post={post} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {content.featured.length > 0 && <FeaturedCustomerSection blok={{ ...content.featured2[0], reverse: true }} />}
    </Layout>
  );
};

export default CustomersListing;

export const query = graphql`
  query CustomerListingQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
